(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('StatementType', StatementType);

    StatementType.$inject = ['$resource'];

    function StatementType ($resource) {
        var resourceUrl =  'api/statement-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
